import React,{useEffect,useState} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col } from 'react-bootstrap';

import './OurFeatures.styles.css';
// import Features from '../../mockups/headerFeatures.json';

const OurFeatures = () => {
  
  const [featureList,setFeatureList]=useState([]);

  const getFeatures= async () => {
      await Axios.get('/cms1/HHFeatures')
      .then(function (response) {
      if(response.data && response.data.data){
        const responseData=response.data.data.HHFeatures;
        if(responseData.length>0){
          setFeatureList(responseData);
        }
        else{
          setFeatureList([]);
        }
      }})
      .catch(function (error) {
        setFeatureList([]);
      });
  };

  useEffect(() => {
    getFeatures();
  }, [])

  return (
    <div className="our-features-box hidden-xs">
      <Container fluid>
        <Row>
        {featureList && featureList?.map(feature => (
            <Col xs={12} md={3} sm={6} key={feature.id}>

              <div className="feature-box first"> <i className={feature?.icon || "icon-plane icons"}></i>
                <div className="content">
                  <h3>{feature?.title || "Free & Next Day Delivery"}</h3>
                </div>
              </div>
            </Col>
          ))}
          {/* {Features && Features?.map(feature => (
            <Col xs={12} md={3} sm={6}>

              <div className="feature-box first"> <i className={feature?.icon || "icon-plane icons"}></i>
                <div className="content">
                  <h3>{feature?.title || "Free & Next Day Delivery"}</h3>
                </div>
              </div>
            </Col>
          ))} */}
          {/* <Col xs={12} md={3} sm={6}>
            <div className="feature-box"> <i className="icon-earphones-alt icons"></i>
              <div className="content">
                <h3>Support 24/7 For Clients</h3>
              </div>
            </div>
          </Col>
          <Col xs={12} md={3} sm={6}>
            <div className="feature-box"> <i className="icon-like icons"></i>
              <div className="content">
                <h3>100% Satisfaction Guarantee</h3>
              </div>
            </div>
          </Col>
          <Col xs={12} md={3} sm={6}>
            <div className="feature-box last"> <i className="icon-tag icons"></i>
              <div className="content">
                <h3>Great Daily Deals Discount</h3>
              </div>
            </div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default OurFeatures;
